<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-3" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{$t('Sales-Distribution-Report')}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="pink lighten-1" dark @click="openMailDialog" small>
                <v-icon left>email</v-icon> Mail Gönder
              </v-btn>
              <v-menu bottom="" left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()"  v-if="PB=='TRY'">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

<!-- MAIL GÖNDER DIALOG -->
<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>
  <v-card>
    <v-toolbar dense flat color="info" dark>
      <v-toolbar-title>Mail Gönder</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>
    </v-toolbar>

    <v-card-text>
      <v-form ref="mailForm" v-model="mailValid" lazy-validation>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              v-model="mailPayload.To"
              label="Kime (e-posta)"
              :rules="[rules.required, rules.email]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgencyName"
              label="Agency Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.DocType"
              label="Doc Type (sabit)"
              :rules="[rules.required]"
              :disabled="true"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgentFullName"
              label="Agent Full Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-textarea
              v-model="mailPayload.CustomBody"
              label="Mesaj"
              :rules="[rules.required]"
              auto-grow
              rows="3"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>
      <v-btn
        color="info"
        :loading="mailLoading"
        :disabled="!mailValid || mailLoading"
        @click="sendMail"
      >
        <v-icon left>send</v-icon>Gönder
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
          <v-container fluid>

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>

                <v-flex xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>

                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BaslangicTarih" v-model="Rapor.BaslangicTarih"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BitisTarih" v-model="Rapor.BitisTarih"></tarihcomp>
                      </v-flex>
                      <v-flex xs12 pt-2 sm2 md2>

                        <v-radio-group v-model="RaporDurumu" row>
                          <v-radio label="Normal" value="0"></v-radio>
                          <v-radio :label="$t('Comparative')" value="1"></v-radio>
                        </v-radio-group>
                      </v-flex>


                      <v-flex xs12 pt-2 sm6 md2>
                        <v-select hide-details="" clearable="" :items="tipitems" :label="$t('Report-Type')" item-text="text"
                          v-model="Rapor.RaporTip" item-value="value">
                        </v-select>
                      </v-flex>



                      <v-flex pt-2>
                        <v-layout>
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small="" dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout pt-3 align-center="">
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">
                                check_circle_outline </v-icon>
                            </template>

                            <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom="" :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>



                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex v-if="RaporDurumu=='1'" pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>

                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Previous-Commencement-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.OncekiBaslangicTarih" v-model="Rapor.OncekiBaslangicTarih"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp :etiket="$t('Previous-Date-Completion')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.OncekiBitisTarih" v-model="Rapor.OncekiBitisTarih"></tarihcomp>
                      </v-flex>

                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-toolbar flat="" size="120px" dark color="grey darken-5">
                              <v-toolbar-title> <span class="subheading white--text">
                                Distribution of Sales by Airline (Domestic)
                                </span> </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-flex xs6 sm6 md6>
                                <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet"
                                  :label="$t('Search')" append-icon="search"></v-text-field>
                              </v-flex>
                            </v-toolbar>

                          </v-flex>

                          <v-flex xs12 sm12>
                            <v-card flat>
                              <ReportTable
                                :headers="salesDistributionHeaders"
                                :items="salesDistributionCurrentDomesticItems"
                                storage-key="satisdagilimi_current_domestic_columns"
                                :loading="progress"
                                :has-searched="reportHasSearched"
                                :show-search="true"
                                :search-label="$t('Search')"
                                :show-frontend-export="true"
                                :export-title="$t('Sales-Distribution-Report') + ' - ' + $t('Domestic-Line')"
                                :export-meta-items="salesDistributionExportMetaItems"
                                :export-summary-cards="salesDistributionCurrentDomesticSummary"
                                :rows-per-page-items="[20,50,100,250,500,1000]"
                              ></ReportTable>
                            </v-card>
                          </v-flex>

                          <v-flex ma-2 xs12 sm12 md12>
                            <v-layout align-center="" justify-center="" fill-height="">
                              <span class="subheading grey--text font-weight-bold">
                                {{$t('Domestic-Flight-Grand-Totals')}}
                              </span>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Sales')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamichat.Satis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> Tax
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamichat.Tax | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Refund')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamichat.Iade | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Return-Tax') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamichat.IadeTax | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Net-Sales') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamichat.NetSatis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Net-Tax') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamichat.NetTax | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Net') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamichat.Net | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> Servis
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamichat.Servis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Commission')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamichat.Komisyon | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Discount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamichat.Iskonto| moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Profit') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamichat.Kar | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> %
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamichat.KarYuzde }}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Sales-Amount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamichat.SatisAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Number-of-Refunds')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamichat.IadeAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Service-Basis') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamichat.ServisMatrah | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{this.$t('ServiceVat')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamichat.ServisKdv | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Analysis')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamichat.Analiz | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>


                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>


                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-toolbar flat="" size="120px" dark color="grey darken-5">
                              <v-toolbar-title> <span class="subheading white--text">
                                Distribution of Sales by Airline  ({{$t('International-Line')}})
                                </span> </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-flex xs6 sm6 md6>
                                <v-text-field flat="" solo-inverted="" hide-details v-model="searchiadebilet"
                                  :label="$t('Search')" append-icon="search"></v-text-field>
                              </v-flex>
                            </v-toolbar>
                          </v-flex>

                          <v-flex xs12 sm12>
                            <v-card flat>
                              <ReportTable
                                :headers="salesDistributionHeaders"
                                :items="salesDistributionCurrentInternationalItems"
                                storage-key="satisdagilimi_current_international_columns"
                                :loading="progress"
                                :has-searched="reportHasSearched"
                                :show-search="true"
                                :search-label="$t('Search')"
                                :show-frontend-export="true"
                                :export-title="$t('Sales-Distribution-Report') + ' - ' + $t('International-Line')"
                                :export-meta-items="salesDistributionExportMetaItems"
                                :export-summary-cards="salesDistributionCurrentInternationalSummary"
                                :rows-per-page-items="[20,50,100,250,500,1000]"
                              ></ReportTable>
                            </v-card>
                          </v-flex>

                          <v-flex ma-2 xs12 sm12 md12>
                            <v-layout align-center="" justify-center="" fill-height="">
                              <span class="subheading grey--text font-weight-bold">
                              {{$t('International-Flight-Grand-Totals')}}
                              </span>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Sales')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamdishat.Satis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> Tax
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamdishat.Tax | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Refund')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamdishat.Iade | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Return-Tax') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamdishat.IadeTax | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Net-Sales') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamdishat.NetSatis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Net-Tax') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamdishat.NetTax | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{  $t('Net') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamdishat.Net | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Service')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamdishat.Servis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Commission')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamdishat.Komisyon | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t("Discount") }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamdishat.Iskonto| moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Profit')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamdishat.Kar | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> %
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamdishat.KarYuzde}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Sales-Amount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamdishat.SatisAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Number-of-Refunds')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamdishat.IadeAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Service-Basis') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamdishat.ServisMatrah | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{this.$t('ServiceVat')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamdishat.ServisKdv | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Analysis')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamdishat.Analiz | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>


                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>


                <v-flex xs12 sm12 pb-3 md12>
                  <v-card class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-toolbar flat="" size="120px" dark color="grey darken-5">
                              <v-toolbar-title> <span class="subheading white--text">
                                  {{$t('Grand-Total')}}
                                </span> </v-toolbar-title>
                              <v-spacer></v-spacer>
                            </v-toolbar>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Sales')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamgenel.Satis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> Tax
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamgenel.Tax | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Refund')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamgenel.Iade | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Return-Tax') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamgenel.IadeTax | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Net-Sales') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamgenel.NetSatis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Net-Tax') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamgenel.NetTax | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{  $t('Net') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamgenel.Net | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Service')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamgenel.Servis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Commission')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamgenel.Komisyon | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Discount')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamdishat.Iskonto | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold">Kar
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamgenel.Kar | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> %
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamgenel.KarYuzde}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Sales-Amount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamgenel.SatisAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Number-of-Refunds')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamgenel.IadeAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Service-Basis') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamgenel.ServisMatrah | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{this.$t('ServiceVat')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamgenel.ServisKdv | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Analysis')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{dipToplamgenel.Analiz | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>

                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>





                <v-flex v-if="RaporDurumu=='1'" xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-toolbar flat="" size="120px" dark color="red">
                              <v-toolbar-title> <span class="subheading white--text">
                                  Satışların {{this.baslik}} Göre Önceki Dönem Dağılımı (İç Hat)
                                </span> </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-flex xs6 sm6 md6>
                                <v-text-field flat="" solo-inverted="" hide-details v-model="onsearchsatilanbilet"
                                  :label="$t('Search')" append-icon="search"></v-text-field>
                              </v-flex>
                            </v-toolbar>

                          </v-flex>

                          <v-flex xs12 sm12>
                            <v-card flat>
                              <ReportTable
                                :headers="salesDistributionHeaders"
                                :items="salesDistributionPreviousDomesticItems"
                                storage-key="satisdagilimi_previous_domestic_columns"
                                :loading="progress"
                                :has-searched="reportHasSearched"
                                :show-search="true"
                                :search-label="$t('Search')"
                                :show-frontend-export="true"
                                :export-title="$t('Sales-Distribution-Report') + ' - ' + $t('Domestic-Line')"
                                :export-meta-items="salesDistributionExportMetaItems"
                                :export-summary-cards="salesDistributionPreviousDomesticSummary"
                                :rows-per-page-items="[20,50,100,250,500,1000]"
                              ></ReportTable>
                            </v-card>
                          </v-flex>

                          <v-flex ma-2 xs12 sm12 md12>
                            <v-layout align-center="" justify-center="" fill-height="">
                              <span class="subheading grey--text font-weight-bold">
                                {{ $t('General-Total-Previous-Period-Domestic-Lines') }}
                              </span>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Sales')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamichat.Satis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Tax-v2') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamichat.Tax | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Refund')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamichat.Iade | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Return-Tax') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamichat.IadeTax | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Net-Sales') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamichat.NetSatis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Net-Tax') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamichat.NetTax | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Net') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamichat.Net | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> Servis
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamichat.Servis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Commission')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamichat.Komisyon | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Discount')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamichat.Iskonto| moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Profit')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamichat.Kar | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> %
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamichat.KarYuzde}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Sales-Amount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamichat.SatisAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Number-of-Refunds')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamichat.IadeAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Service-Basis') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamichat.ServisMatrah | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{this.$t('ServiceVat')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamichat.ServisKdv | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Analysis')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamichat.Analiz | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                              </v-layout>
                            </v-card>
                          </v-flex>


                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex v-if="RaporDurumu=='1'" xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-toolbar flat="" size="120px" dark color="red darken-5">
                              <v-toolbar-title> <span class="subheading white--text">
                                  Satışların {{this.baslik}} Göre Önceki Dönem Dağılımı ({{$t('International-Line')}})
                                </span> </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-flex xs6 sm6 md6>
                                <v-text-field flat="" solo-inverted="" hide-details v-model="onsearchiadebilet"
                                  :label="$t('Search')" append-icon="search"></v-text-field>
                              </v-flex>
                            </v-toolbar>
                          </v-flex>

                          <v-flex xs12 sm12>
                            <v-card flat>
                              <ReportTable
                                :headers="salesDistributionHeaders"
                                :items="salesDistributionPreviousInternationalItems"
                                storage-key="satisdagilimi_previous_international_columns"
                                :loading="progress"
                                :has-searched="reportHasSearched"
                                :show-search="true"
                                :search-label="$t('Search')"
                                :show-frontend-export="true"
                                :export-title="$t('Sales-Distribution-Report') + ' - ' + $t('International-Line')"
                                :export-meta-items="salesDistributionExportMetaItems"
                                :export-summary-cards="salesDistributionPreviousInternationalSummary"
                                :rows-per-page-items="[20,50,100,250,500,1000]"
                              ></ReportTable>
                            </v-card>
                          </v-flex>
                          <v-flex ma-2 xs12 sm12 md12>
                            <v-layout align-center="" justify-center="" fill-height="">
                              <span class="subheading grey--text font-weight-bold">
                                Dış Hat Önceki Dönem Genel Toplamlar
                              </span>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Sales')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamdishat.Satis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> Tax
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamdishat.Tax | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Refund')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamdishat.Iade | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Return-Tax') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamdishat.IadeTax | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Net-Sales') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamdishat.NetSatis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Net-Tax') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamdishat.NetTax | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Net') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamdishat.Net | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Service')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamdishat.Servis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Commission')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamdishat.Komisyon | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Discount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamdishat.Iskonto | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Profit') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamdishat.Kar | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> %
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamdishat.KarYuzde}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Sales-Amount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamdishat.SatisAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Number-of-Refunds')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamdishat.IadeAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Service-Basis') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamdishat.ServisMatrah | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{this.$t('ServiceVat')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamdishat.ServisKdv | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Analysis')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamdishat.Analiz | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>


                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex v-if="RaporDurumu=='1'" xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-toolbar flat="" size="120px" dark color="red darken-5">
                              <v-toolbar-title> <span class="subheading white--text">
                                 {{$t('Prior-Period-Grand-Total')}}
                                </span> </v-toolbar-title>
                              <v-spacer></v-spacer>
                            </v-toolbar>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Sales')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamgenel.Satis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Tax-v2') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamgenel.Tax | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Refund')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamgenel.Iade | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Return-Tax') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamgenel.IadeTax | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Net-Sales') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamgenel.NetSatis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Net-Tax') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamgenel.NetTax | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Net') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamgenel.Net | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Service')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamgenel.Servis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Commission')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamgenel.Komisyon | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Discount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamgenel.Iskonto | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Profit') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamgenel.Kar | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> %
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamgenel.KarYuzde}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Sales-Amount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamgenel.SatisAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Number-of-Refunds')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamgenel.IadeAdet }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Service-Basis') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamgenel.ServisMatrah | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{this.$t('ServiceVat')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamgenel.ServisKdv | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Analysis')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ondipToplamgenel.Analiz | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>



                              </v-layout>
                            </v-card>
                          </v-flex>

                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>



          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
            <v-card color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm12 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">
                            <v-flex v-if="Rapor.RaporTip=='Masraf'" xs12 sm12 md12>
                              <v-select :items="masrafmerkeziitems" v-model="masrafmerkezikodu" :label="$t('Expense-Center-v2')"
                                multiple item-text="Title" item-value="Code">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <v-chip v-if="index === 0">
                                    <h4> <span>{{ item.Code }}</span> </h4>
                                  </v-chip>
                                  <span v-if="index === 1" class="grey--text caption">(+{{
                             masrafmerkezikodu.length - 1 }} {{ $t('other-record') }})</span>
                                </template>
                              </v-select>
                            </v-flex>
                            <v-flex v-if="Rapor.RaporTip=='Havayolu'" xs12 sm12 md12>
                              <v-autocomplete hide-details="" clearable :items="itemsairlinelist"
                                :label="$t('Select-Airline')" multiple item-text="Title" v-model="havayolukodu"
                                item-value="HavaYoluKodu">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <div v-if="index === 0">
                                    <span>{{ item.HavaYoluKodu }}</span>
                                  </div>
                                  <span v-if="index === 1" class="grey--text caption">(+{{
                                                                havayolukodu.length -
                                                                1
                                                                }} {{$t('Other')}})</span>
                                </template>
                              </v-autocomplete>
                            </v-flex>

                            <v-flex v-if="Rapor.RaporTip=='Bolum'" xs12 sm12 md12>
                              <v-autocomplete hide-details="" clearable :items="bolumitems" label="Bölüm Seçimi"
                                multiple item-text="Title" v-model="bolumdegeri" item-value="BolumKodu">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <div v-if="index === 0">
                                    <span>{{ item.Title }}</span>
                                  </div>
                                  <span v-if="index === 1" class="grey--text caption">(+{{
                                                                bolumdegeri.length -
                                                                1
                                                                }} {{$t('Other')}})</span>
                                </template>
                              </v-autocomplete>

                            </v-flex>


                            <v-flex v-if="Rapor.RaporTip=='KesenKisi'" xs12 sm12 md12>
                              <v-autocomplete hide-details="" clearable :items="kesenkisiitems" label="Bölüm Seçimi"
                                multiple item-text="Adi" v-model="kesenkisi" item-value="Kodu">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <div v-if="index === 0">
                                    <span>{{ item.Adi }}</span>
                                  </div>
                                  <span v-if="index === 1" class="grey--text caption">(+{{
                                                                kesenkisi.length -
                                                                1
                                                                }} {{$t('Other')}})</span>
                                </template>
                              </v-autocomplete>

                            </v-flex>

                            <v-flex v-if="Rapor.RaporTip=='Referans'" xs12 sm12 md12>
                              <referansmerkezicomp :coper="false" :tabdeger="'37'" v-model="referansdegeri">
                                                        </referansmerkezicomp>

                              <!-- <v-select :items="referansitems" hide-details v-model="referansdegeri" :label="$t('References')"
                                multiple item-text="Title" item-value="Kod">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <v-chip v-if="index === 0">
                                    <h4> <span>{{ item.Kod }}</span> </h4>
                                  </v-chip>
                                  <span v-if="index === 1" class="grey--text caption">(+{{
                                 referansdegeri.length - 1 }} {{ $t('other-record') }} )</span>
                                </template>
                              </v-select> -->
                            </v-flex>

                              <v-flex xs12 sm12 md12>
                            <v-layout justify-space-between column>
                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                            </v-layout>
                          </v-flex>

                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>



                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"
  import bolumcomp from "@/components/app/bilet/partpage/bolumcomp.vue"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import ReportTable from '@/components/app/customcomp/ReportTable.vue'


  export default {
    data() {
      return {
        mailDialog: false,
        mailValid: false,
        mailLoading: false,
        mailPayload: {
          To: "",
          AgencyName: "",
          DocType: "Sales Distribution Report", 
          AgentFullName: "",
          CustomBody: ""
        },
        rules: {
          required: v => !!v || 'Zorunlu alan',
          email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'
        },
        PB:'TRY',
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        reportHasSearched: false,
        kesenkisi: null,
        kesenkisiitems: [],
        bolumitems: [],
        itemsairlinelist: [],
        havayolukodu: null,
        masrafmerkeziitems: [],
        referansitems: [],
        evraktipi: [],
        search: '',
        searchsatilanbilet: null,
        onsearchsatilanbilet: null,
        searchiadebilet: null,
        onsearchiadebilet: null,
        searchvoid: null,
        RaporDurumu: '0',
    
        dipToplamichat: {
          Analiz: 0,
          Iade: 0,
          IadeAdet: 0,
          IadeTax: 0,
          Iskonto: 0,
          Kar: 0,
          KarYuzde: 0,
          Komisyon: 0,
          Net: 0,
          NetSatis: 0,
          NetTax: 0,
          Satis: 0,
          SatisAdet: 0,
          Servis: 0,
          ServisKdv: 0,
          ServisMatrah: 0,
          Tax: 0
        },

        dipToplamdishat: {
          Analiz: 0,
          Iade: 0,
          IadeAdet: 0,
          IadeTax: 0,
          Iskonto: 0,
          Kar: 0,
          KarYuzde: 0,
          Komisyon: 0,
          Net: 0,
          NetSatis: 0,
          NetTax: 0,
          Satis: 0,
          SatisAdet: 0,
          Servis: 0,
          ServisKdv: 0,
          ServisMatrah: 0,
          Tax: 0
        },

        dipToplamgenel: {
          Analiz: 0,
          Iade: 0,
          IadeAdet: 0,
          IadeTax: 0,
          Iskonto: 0,
          Kar: 0,
          KarYuzde: 0,
          Komisyon: 0,
          Net: 0,
          NetSatis: 0,
          NetTax: 0,
          Satis: 0,
          SatisAdet: 0,
          Servis: 0,
          ServisKdv: 0,
          ServisMatrah: 0,
          Tax: 0
        },

        ondipToplamichat: {
          Analiz: 0,
          Iade: 0,
          IadeAdet: 0,
          IadeTax: 0,
          Iskonto: 0,
          Kar: 0,
          KarYuzde: 0,
          Komisyon: 0,
          Net: 0,
          NetSatis: 0,
          NetTax: 0,
          Satis: 0,
          SatisAdet: 0,
          Servis: 0,
          ServisKdv: 0,
          ServisMatrah: 0,
          Tax: 0
        },

        ondipToplamdishat: {
          Analiz: 0,
          Iade: 0,
          IadeAdet: 0,
          IadeTax: 0,
          Iskonto: 0,
          Kar: 0,
          KarYuzde: 0,
          Komisyon: 0,
          Net: 0,
          NetSatis: 0,
          NetTax: 0,
          Satis: 0,
          SatisAdet: 0,
          Servis: 0,
          ServisKdv: 0,
          ServisMatrah: 0,
          Tax: 0
        },

        ondipToplamgenel: {
          Analiz: 0,
          Iade: 0,
          IadeAdet: 0,
          IadeTax: 0,
          Iskonto: 0,
          Kar: 0,
          KarYuzde: 0,
          Komisyon: 0,
          Net: 0,
          NetSatis: 0,
          NetTax: 0,
          Satis: 0,
          SatisAdet: 0,
          Servis: 0,
          ServisKdv: 0,
          ServisMatrah: 0,
          Tax: 0
        },


        baslik: ' Havayoluna ',

        Rapor: {
          RaporTip: 'Havayolu',
          DegiskenAlan: [],
          SirketKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
          OncekiBaslangicTarih: null,
          OncekiBitisTarih: null

        },

        valid: true,
        tumsirketler: '',

        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        searchcari: '',
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemsichat: [],
        itemsdishat: [],
        onitemsichat: [],
        onitemsdishat: [],
        masrafmerkezikodu: null,
        referansdegeri: [],
        bolumdegeri: null,
        havayolubil: {
          havayolukodu: null,
          formno: null
        },
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {
            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB=credentials.ParaBirimi
        var params = {
          CompanyCode: credentials.SirketKodu
        }


        this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.masrafmerkeziitems = response.body
        }, (response) => {
          if (response.status === 0) {

          } else {

          }
        })




      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var url = '#/'
              window.open(url, '_self')
            }
          } else {

          }

        });

      }
    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    components: {
      'tarihcomp': tarihcomp,
      referansmerkezicomp,
      masrafmerkezicomp,
      havayollaricomp,
      bolumcomp,
      yetkidialog,
      ReportTable
    },
    watch: {
      'Rapor.RaporTip': function (val) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          CompanyCode: credentials.SirketKodu
        }


        if (val == "Masraf") {
          this.baslik = this.$t('Expense-Center')

          this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.masrafmerkeziitems = response.body
          }, (response) => {
            if (response.status === 0) {

            } else {

            }
          })

        }
        if (val == "Referans") {
          this.baslik = this.$t('Reference')



          // this.$http.post(auth.API_URL + 'api/Reference/List', params, {
          //   headers: {
          //     'Authorization': 'Bearer ' + auth.getAuthHeader()
          //   }
          // }).then((response) => {
          //   this.referansitems = response.body
          // }, (response) => {
          //   if (response.status === 0) {
          //     this.text1 = 'Service Unavailable'
          //     this.snackbar = true
          //   } else {
          //     this.text1 = 'Service Unavailable'
          //     this.snackbar = true
          //   }
          // })

        }
        if (val == "Havayolu") {
          this.baslik = "Havayoluna"

          this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.itemsairlinelist = response.body
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.progress = false

              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.progress = false

              this.snackbar = true
            }
          })
        }
        if (val == "Bolum") {
          this.baslik = "Bölüme"

          this.$http.post(auth.API_URL + 'api/Definitions/SectionList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.bolumitems = response.body
            this.progress = false
          }, (response) => {
            if (response.status === 0) {
              this.progress = false
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.progress = false
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        }
        if (val == 'KesenKisi') {
          var params1 = {
            SirketKodu: credentials.SirketKodu
          }

          this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            this.kesenkisiitems = response.body
          }, (response) => {
            if (response.status === 0) {
              this.progress = false
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.progress = false
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        }
      }
    },
    methods: {
  normalizeSalesDistributionRows(list){
    return (list||[]).map(function(item){
      var row=Object.assign({},item);
      var totals=item&&item.Tutarlar?item.Tutarlar:{};
      Object.keys(totals).forEach(function(key){ row['_'+key.replace('İskonto','Iskonto')]=totals[key]; });
      return row;
    });
  },
  buildSalesDistributionSummary(title,source){
    var item=source||{};
    return[{title:title,items:[
      {label:this.$t('Sales'),value:item.Satis||0,type:'money'},
      {label:this.$t('Tax-v2'),value:item.Tax||0,type:'money'},
      {label:this.$t('Refund'),value:item.Iade||0,type:'money'},
      {label:this.$t('Return-Tax'),value:item.IadeTax||0,type:'money'},
      {label:this.$t('Net-Sales'),value:item.NetSatis||0,type:'money'},
      {label:this.$t('Net-Tax'),value:item.NetTax||0,type:'money'},
      {label:this.$t('Net'),value:item.Net||0,type:'money'},
      {label:this.$t('Service'),value:item.Servis||0,type:'money'},
      {label:this.$t('Commission'),value:item.Komisyon||0,type:'money'},
      {label:this.$t('Discount'),value:item.Iskonto||item.İskonto||0,type:'money'},
      {label:this.$t('Profit'),value:item.Kar||0,type:'money'},
      {label:this.$t('Percentage'),value:item.KarYuzde||0,type:'number'},
      {label:this.$t('Sales-Amount'),value:item.SatisAdet||0,type:'number'},
      {label:this.$t('Number-of-Refunds'),value:item.IadeAdet||0,type:'number'},
      {label:this.$t('Service-Basis'),value:item.ServisMatrah||0,type:'money'},
      {label:this.$t('Service-VAT'),value:item.ServisKdv||0,type:'money'},
      {label:this.$t('Analysis'),value:item.Analiz||0,type:'money'}
    ]}];
  },

  openMailDialog() {
    if (this.$refs && this.$refs.mailForm && this.$refs.mailForm.reset) {
      this.$refs.mailForm.reset();
    }
    if (this.mailPayload && !this.mailPayload.DocType) {
      this.mailPayload.DocType = "Satış Dağılım Raporu - Sales Distribution Report";
    }
    this.mailDialog = true;
  },

  closeMailDialog() {
    this.mailDialog = false;
  },

  sendMail() {
    const _this = this;

    if (!(_this.$refs && _this.$refs.mailForm && _this.$refs.mailForm.validate && _this.$refs.mailForm.validate())) {
      return;
    }

    const bas = _this.Rapor && _this.Rapor.BaslangicTarih ? new Date(_this.Rapor.BaslangicTarih) : null;
    const bit = _this.Rapor && _this.Rapor.BitisTarih ? new Date(_this.Rapor.BitisTarih) : null;
    if (!(bas && bit) || bas > bit) {
      _this.text1 = _this.$t('start-date-cannot-greater-than-end-date');
      _this.snackbar = true;
      return;
    }

    const credentialsRaw = window.localStorage.getItem('credentials');
    const credentials = credentialsRaw ? JSON.parse(credentialsRaw) : {};
    const companyCode = (credentials && credentials.SirketKodu) ? parseInt(credentials.SirketKodu, 10) : 0;

    const raporTip =
      (_this.Rapor && typeof _this.Rapor.RaporTip !== 'undefined')
        ? _this.Rapor.RaporTip
        : (typeof _this.RaporTip !== 'undefined' ? _this.RaporTip : 0);

    const degiskenAlan = Array.isArray(_this.DegiskenAlan) ? _this.DegiskenAlan
                       : (_this.Rapor && Array.isArray(_this.Rapor.DegiskenAlan)) ? _this.Rapor.DegiskenAlan
                       : [];

    let oncekiBaslangic = null;
    let oncekiBitis = null;

    const mukayeseli =
      (_this.Rapor && _this.Rapor.Mukayeseli === true) ||
      (_this.Mukayeseli === true);

    if (mukayeseli) {
      if (_this.Rapor && _this.Rapor.OncekiBaslangicTarih && _this.Rapor.OncekiBitisTarih) {
        oncekiBaslangic = _this.Rapor.OncekiBaslangicTarih;
        oncekiBitis = _this.Rapor.OncekiBitisTarih;
      } else {
        const dayMs = 24 * 60 * 60 * 1000;
        const diffDays = Math.floor((bit - bas) / dayMs) + 1;
        const prevEnd = new Date(bas.getTime() - dayMs);
        const prevStart = new Date(prevEnd.getTime() - (diffDays - 1) * dayMs);
        oncekiBaslangic = prevStart.toISOString().slice(0, 10);
        oncekiBitis = prevEnd.toISOString().slice(0, 10);
      }
    }

    const payload = {
      Input: {
        SirketKodu: companyCode,
        BaslangicTarih: _this.Rapor.BaslangicTarih,
        BitisTarih: _this.Rapor.BitisTarih,
        RaporTip: raporTip,
        DegiskenAlan: degiskenAlan
      },
      Mail: {
        To: (_this.mailPayload && _this.mailPayload.To) ? _this.mailPayload.To : "",
        AgencyName: (_this.mailPayload && _this.mailPayload.AgencyName) ? _this.mailPayload.AgencyName : "",
      DocType:       (_this.mailPayload && _this.mailPayload.DocType)       ? _this.mailPayload.DocType       : "Satışların Dağılım Raporu - Sales Distribution Report",
        AgentFullName: (_this.mailPayload && _this.mailPayload.AgentFullName) ? _this.mailPayload.AgentFullName : "",
        CustomBody: (_this.mailPayload && _this.mailPayload.CustomBody) ? _this.mailPayload.CustomBody : ""
      }
    };

    if (mukayeseli && oncekiBaslangic && oncekiBitis) {
      payload.Input.OncekiBaslangicTarih = oncekiBaslangic;
      payload.Input.OncekiBitisTarih = oncekiBitis;
    }

    _this.mailLoading = true;

    const endpoint = auth.API_URL + 'api/TicketReport/MailGonderSalesDistributionExcel';

    _this.$http.post(
      endpoint,
      payload,
      { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }
    ).then(function () {
      _this.mailLoading = false;
      _this.mailDialog = false;
      _this.text1 = 'Mail gönderildi.';
      _this.snackbar = true;
    }, function (err) {
      _this.mailLoading = false;
      const body = (err && (err.body || err.data)) ? (err.body || err.data) : {};
      const msg = (body && (body.Message || body.message)) || err.statusText || 'Mail gönderilemedi.';
      _this.text1 = msg;
      _this.snackbar = true;
    });
  },




      getparabirimi() {
        return helpers.getparabirimi()
      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    },
    computed:{
          salesDistributionHeaders() {
            var moneyKeys=['Satis','Tax','Iade','IadeTax','NetSatis','NetTax','Net','Servis','Komisyon','Iskonto','Kar','ServisMatrah','ServisKdv','Analiz'];
            var numberKeys=['KarYuzde','SatisAdet','IadeAdet'];
            return (this.headers || []).map(function(header){
              var item=Object.assign({},header);
              if(item.value && item.value.indexOf('Tutarlar.')===0){
                var key=item.value.substring(9).replace('İskonto','Iskonto');
                item.value='_'+key;
                item.type=moneyKeys.indexOf(key)!==-1?'money':(numberKeys.indexOf(key)!==-1?'number':'text');
              } else {
                item.type='text';
              }
              item.visible=true;
              item.sortable=true;
              return item;
            });
          },
          salesDistributionCurrentDomesticItems(){ return this.normalizeSalesDistributionRows(this.itemsichat); },
          salesDistributionCurrentInternationalItems(){ return this.normalizeSalesDistributionRows(this.itemsdishat); },
          salesDistributionPreviousDomesticItems(){ return this.normalizeSalesDistributionRows(this.onitemsichat); },
          salesDistributionPreviousInternationalItems(){ return this.normalizeSalesDistributionRows(this.onitemsdishat); },
          salesDistributionExportMetaItems(){
            var reportType=(this.tipitems||[]).find((item)=>item.value===this.Rapor.RaporTip);
            return[
              {label:this.$t('Starting-Date'),value:this.Rapor.BaslangicTarih,type:'date'},
              {label:this.$t('Finishing-Date'),value:this.Rapor.BitisTarih,type:'date'},
              {label:this.$t('Report-Type'),value:reportType?reportType.text:''},
              {label:this.$t('Previous-Commencement-Date'),value:this.RaporDurumu=='1'?this.Rapor.OncekiBaslangicTarih:'',type:'date'},
              {label:this.$t('Previous-Date-Completion'),value:this.RaporDurumu=='1'?this.Rapor.OncekiBitisTarih:'',type:'date'},
              {label:this.$t('Expense-Center-v2'),value:this.masrafmerkezikodu||''},
              {label:this.$t('Reference'),value:Array.isArray(this.referansdegeri)?this.referansdegeri.join(', '):(this.referansdegeri||'')},
              {label:this.$t('Department-Code'),value:this.bolumdegeri||''},
              {label:this.$t('Airline-Code'),value:this.havayolubil&&this.havayolubil.havayolukodu?this.havayolubil.havayolukodu:''},
              {label:this.$t('All-Companies'),value:this.tumsirketler===true?'Evet':'Hayır'}
            ];
          },
          salesDistributionCurrentDomesticSummary(){ return this.buildSalesDistributionSummary(this.$t('Domestic-Flight-Grand-Totals'),this.dipToplamichat); },
          salesDistributionCurrentInternationalSummary(){ return this.buildSalesDistributionSummary(this.$t('International-Flight-Grand-Totals'),this.dipToplamdishat); },
          salesDistributionPreviousDomesticSummary(){ return this.buildSalesDistributionSummary(this.$t('General-Total-Previous-Period-Domestic-Lines'),this.ondipToplamichat); },
          salesDistributionPreviousInternationalSummary(){ return this.buildSalesDistributionSummary(this.$t('International-Line'),this.ondipToplamdishat); },
          tipitems(){
            return [{
            text: this.$t('Per-Airline'),
            value: 'Havayolu'
          }, {
            text: this.$t('Per-Issuing-Party'),
            value: 'KesenKisi'
          },
          {
            text: this.$t('Per-Expense-Centre'),
            value: 'Masraf'
          }, {
            text: this.$t('Per-Reference'),
            value: 'Referans'
          }
        ]
        },
        headers(){
          return [{
            text: this.$t('Code'),
            value: 'DegiskenAlan'
          },
          {
            text: this.$t('Sales'),
            value: 'Tutarlar.Satis',
          },
          {
            text: this.$t('Tax-v2'),
            value: 'Tutarlar.Tax',
          },
          {
            text: this.$t('Refund'),
            value: 'Tutarlar.Iade',
          },
          {
            text: this.$t('Return-Tax'),
            value: 'Tutarlar.IadeTax',
          },
          {
            text: this.$t('Net-Sales'),
            value: 'Tutarlar.NetSatis',
          },
          {
            text: this.$t('Net-Tax'),
            value: 'Tutarlar.NetTax',
          },
          {
            text: this.$t('Net'),
            value: 'Tutarlar.Net',
          },
          {
            text: this.$t('Service'),
            value: 'Tutarlar.Servis',
          },
          {
            text: this.$t('Commission'),
            value: 'Tutarlar.Komisyon',
          },
          {
            text: this.$t('Discount'),
            value: 'Tutarlar.İskonto',
          },
          {
            text: this.$t('Profit'),
            value: 'Tutarlar.Kar',
          },
          {
            text: '%',
            value: 'Tutarlar.KarYuzde',
          },
          {
            text: this.$t('Sales-Amount'),
            value: 'Tutarlar.SatisAdet',
          },
          {
            text: this.$t('Number-of-Refunds'),
            value: 'Tutarlar.IadeAdet',
          },
          {
            text: this.$t('Service-Basis'),
            value: 'Tutarlar.ServisMatrah',
          },
          {
            text: this.$t('Service-VAT'),
            value: 'Tutarlar.ServisKdv',
          },
          {
            text: this.$t('Analysis'),
            value: 'Tutarlar.Analiz',
          }
        ]
        },
        headersdip(){
          return[{
            text: '',
            value: ''
          },
          {
            text: '',
            value: '',
          },
          {
            text: this.$t('Tax-v2'),
            value: 'Tutarlar.Tax',
          },
          {
            text: this.$t('Refund'),
            value: 'Tutarlar.Iade',
          },
          {
            text: this.$t('Return-Tax'),
            value: 'Tutarlar.IadeTax',
          },
          {
            text: this.$t('Net-Sales'),
            value: 'Tutarlar.NetSatis',
          },
          {
            text: this.$t('Net-Tax'),
            value: 'Tutarlar.NetTax',
          },
          {
            text: this.$t('Net'),
            value: 'Tutarlar.Net',
          },
          {
            text: this.$t('Service'),
            value: 'Tutarlar.Servis',
          },
          {
            text: this.$t('Commission'),
            value: 'Tutarlar.Komisyon',
          },
          {
            text: this.$t('Discount'),
            value: 'Tutarlar.İskonto',
          },
          {
            text: this.$t('Profit'),
            value: 'Tutarlar.Kar',
          },
          {
            text: '%',
            value: 'Tutarlar.KarYuzde',
          },
          {
            text: this.$t('Sales-Amount'),
            value: 'Tutarlar.SatisAdet',
          },
          {
            text: this.$t('Number-of-Refunds'),
            value: 'Tutarlar.IadeAdet',
          },
          {
            text: this.$t('Service-Basis'),
            value: 'Tutarlar.ServisMatrah',
          },
          {
            text: this.$t('Service-VAT'),
            value: 'Tutarlar.ServisKdv',
          },
          {
            text: this.$t('Analysis'),
            value: 'Tutarlar.Analiz',
          }
        ]
        },
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsairlinelist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {

      } else {

      }
    })


  }




  function filtrekayit() {
    this.filtrevarmi = true

    this.dialogfiltre = false
    this.getList()
  }

  function filtreiptal() {

    this.filtrevarmi = false
    this.dialogfiltre = false
    this.Rapor.SirketKodu = null
    this.Rapor.DegiskenAlan = null
    this.tumsirketler = ''
    this.masrafmerkezikodu = null
    this.havayolukodu = null
    this.referansdegeri = null
    this.bolumdegeri = null
    this.kesenkisi = null


  }


  function getList() {

    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.reportHasSearched = true
        this.progress = true
        this.load1 = false

        var listreferans = [];


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        if (this.Rapor.RaporTip == 'Masraf') {
          this.Rapor.DegiskenAlan = this.masrafmerkezikodu
        }
        if (this.Rapor.RaporTip == 'Havayolu') {
          this.Rapor.DegiskenAlan = this.havayolukodu
        }
        if (this.Rapor.RaporTip == 'Referans') {
          this.Rapor.DegiskenAlan = this.referansdegeri
        }
        if (this.Rapor.RaporTip == 'Bolum') {
          this.Rapor.DegiskenAlan = this.bolumdegeri
        }
        if (this.Rapor.RaporTip == 'KesenKisi') {
          this.Rapor.DegiskenAlan = this.kesenkisi
        }

        var params = this.Rapor

        if (this.RaporDurumu == '0') {
          this.Rapor.OncekiBaslangicTarih = null
          this.Rapor.OncekiBitisTarih = null


          this.$http.post(auth.API_URL + 'api/TicketReport/SalesDistributionReport', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            this.itemsichat = response.body.IcHatDetay
            this.itemsdishat = response.body.DisHatDetay
            this.dipToplamichat = response.body.IcHatToplamlar
            this.dipToplamdishat = response.body.DisHatToplamlar
            this.dipToplamgenel = response.body.GenelToplamlar



            this.progress = false
            this.load1 = true

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            }
          })
        } else {

          this.$http.post(auth.API_URL + 'api/TicketReport/SalesDistributionWithComparisonReport', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            this.itemsichat = response.body.DonemDagilimList.IcHatDetay
            this.itemsdishat = response.body.DonemDagilimList.DisHatDetay
            this.dipToplamichat = response.body.DonemDagilimList.IcHatToplamlar
            this.dipToplamdishat = response.body.DonemDagilimList.DisHatToplamlar
            this.dipToplamgenel = response.body.DonemDagilimList.GenelToplamlar


            this.onitemsichat = response.body.OncekiDonemDagilimList.IcHatDetay
            this.onitemsdishat = response.body.OncekiDonemDagilimList.DisHatDetay
            this.ondipToplamichat = response.body.OncekiDonemDagilimList.IcHatToplamlar
            this.ondipToplamdishat = response.body.OncekiDonemDagilimList.DisHatToplamlar
            this.ondipToplamgenel = response.body.OncekiDonemDagilimList.GenelToplamlar



            this.progress = false
            this.load1 = true

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            }
          })
        }



      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }



  function getListHtml() {
    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false

        var listreferans = [];


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var lang = localStorage.getItem('lang')
        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        if (this.Rapor.RaporTip == 'Masraf') {
          this.Rapor.DegiskenAlan = this.masrafmerkezikodu
        }
        if (this.Rapor.RaporTip == 'Havayolu') {
          this.Rapor.DegiskenAlan = this.havayolukodu
        }
        if (this.Rapor.RaporTip == 'Referans') {
          this.Rapor.DegiskenAlan = this.referansdegeri
        }
        if (this.Rapor.RaporTip == 'Bolum') {
          this.Rapor.DegiskenAlan = this.bolumdegeri
        }
        if (this.Rapor.RaporTip == 'KesenKisi') {
          this.Rapor.DegiskenAlan = this.kesenkisi
        }

        var params = this.Rapor

        if (this.RaporDurumu == '0') {
          this.Rapor.OncekiBaslangicTarih = null
          this.Rapor.OncekiBitisTarih = null


          this.$http.post(auth.API_URL + "api/TicketReport/SalesDistributionReportHtml", params, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            }
          }).then((response) => {

            this.itemsichat = response.body.IcHatDetay
            this.itemsdishat = response.body.DisHatDetay
            this.dipToplamichat = response.body.IcHatToplamlar
            this.dipToplamdishat = response.body.DisHatToplamlar
            this.dipToplamgenel = response.body.GenelToplamlar



            this.progress = false
            this.load1 = true
            if (lang=='en')
          {
            
             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> SATIŞ DAĞILIM RAPORU </title>','<title> SALES DISTRIBUTION REPORT </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>SATIŞ DAĞILIM RAPORU</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>SALES DISTRIBUTION REPORT</font>")
             bodyhtml=bodyhtml.toString().replace("İÇ HAT DAĞILIM RAPORU","DOMESTIC DISTRIBUTION REPORT")
             bodyhtml=bodyhtml.toString().replace("DIŞ HAT DAĞILIM RAPORU","INTERNATIONAL DISTRIBUTION REPORT")
             bodyhtml=bodyhtml.toString().replace("Havayolu","Airline")
             bodyhtml=bodyhtml.toString().replace("Bilet No","Ticket No")
             bodyhtml=bodyhtml.toString().replace("Uçuş Type","Flight Type")
             bodyhtml=bodyhtml.toString().replace("Yolcu Name","Passenger Name")
             bodyhtml=bodyhtml.toString().replace("Void Tarihi","Void Date")
             bodyhtml=bodyhtml.toString().replace("Satış Tarihi","Sales Date")
             bodyhtml=bodyhtml.toString().replace("Kesim Tarihi","Cutting Date")
             bodyhtml=bodyhtml.toString().replace("Bilet Amountı","Ticket Amount")
             bodyhtml=bodyhtml.toString().replace("Vergi Tutarı","Tax Amount")
             bodyhtml=bodyhtml.toString().replace("Discount Tutarı","Discount Amount")
             bodyhtml=bodyhtml.toString().replace("Havayolu :","Airline :")
             bodyhtml=bodyhtml.toString().replaceAll("Havayolu","Airline")
             bodyhtml=bodyhtml.toString().replaceAll("Satış","Sales")
             bodyhtml=bodyhtml.toString().replaceAll("Iade","Refund")
             bodyhtml=bodyhtml.toString().replaceAll("Iade Tax","Refund Vat")
             bodyhtml=bodyhtml.toString().replaceAll("Net Satış","Net Sales")
             bodyhtml=bodyhtml.toString().replaceAll("Total Servis","Total Service")
             bodyhtml=bodyhtml.toString().replaceAll("Toplam Komisyon","Total Commision")
             bodyhtml=bodyhtml.toString().replaceAll("Total Komisyon","Total Commision")
             bodyhtml=bodyhtml.toString().replaceAll("Net Iskonto","Net Discount")
             bodyhtml=bodyhtml.toString().replaceAll("Toplam Kar","Total Profit")
             bodyhtml=bodyhtml.toString().replaceAll("Kar %","Profit %")
             bodyhtml=bodyhtml.toString().replaceAll("S. Adet","Sales C.")
             bodyhtml=bodyhtml.toString().replaceAll("I. Adet","Refund C.")
             bodyhtml=bodyhtml.toString().replaceAll("Dış Hat Toplam :","International Line Total:")
             bodyhtml=bodyhtml.toString().replaceAll("İç Hat Toplam :","Domestic Line Total:")
             bodyhtml=bodyhtml.toString().replaceAll("Total Kar","Total Profit")
             bodyhtml=bodyhtml.toString().replaceAll("Toplam Servis","Total Service")
             
             response.bodyText=bodyhtml;
             
          }
            var blob = new Blob([response.bodyText], {
              type: 'application/html'
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = this.$t('SatisDagilim') + ".html";
            link.click();

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            }
          })
        } else {

          this.$http.post(auth.API_URL + "api/TicketReport/SalesDistributionWithComparisonReportHtml", params, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            }
          }).then((response) => {

            this.progress = false
            this.load1 = true
            if (lang=='en')
          {
            
             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title>MUKAYESELİ SATIŞ DAĞILIM RAPORU </title>','<title>COMPARATIVE  SALES DISTRIBUTION REPORT </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>MUKAYESELİ SATIŞ DAĞILIM RAPORU</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>COMPARATIVE SALES DISTRIBUTION REPORT</font>")
             bodyhtml=bodyhtml.toString().replace("İÇ HAT DAĞILIM RAPORU","DOMESTIC DISTRIBUTION REPORT")
             bodyhtml=bodyhtml.toString().replace("DIŞ HAT DAĞILIM RAPORU","INTERNATIONAL DISTRIBUTION REPORT")
             bodyhtml=bodyhtml.toString().replace("Havayolu","Airline")
             bodyhtml=bodyhtml.toString().replace("Bilet No","Ticket No")
             bodyhtml=bodyhtml.toString().replace("Uçuş Type","Flight Type")
             bodyhtml=bodyhtml.toString().replace("Yolcu Name","Passenger Name")
             bodyhtml=bodyhtml.toString().replace("Void Tarihi","Void Date")
             bodyhtml=bodyhtml.toString().replace("Satış Tarihi","Sales Date")
             bodyhtml=bodyhtml.toString().replace("Kesim Tarihi","Cutting Date")
             bodyhtml=bodyhtml.toString().replace("Bilet Amountı","Ticket Amount")
             bodyhtml=bodyhtml.toString().replace("Vergi Tutarı","Tax Amount")
             bodyhtml=bodyhtml.toString().replace("Discount Tutarı","Discount Amount")
             bodyhtml=bodyhtml.toString().replace("Havayolu :","Airline :")
             bodyhtml=bodyhtml.toString().replaceAll("Havayolu","Airline")
             bodyhtml=bodyhtml.toString().replaceAll("Satış","Sales")
             bodyhtml=bodyhtml.toString().replaceAll("Iade","Refund")
             bodyhtml=bodyhtml.toString().replaceAll("Iade Tax","Refund Vat")
             bodyhtml=bodyhtml.toString().replaceAll("Net Satış","Net Sales")
             bodyhtml=bodyhtml.toString().replaceAll("Total Servis","Total Service")
             bodyhtml=bodyhtml.toString().replaceAll("Toplam Komisyon","Total Commision")
             bodyhtml=bodyhtml.toString().replaceAll("Total Komisyon","Total Commision")
             bodyhtml=bodyhtml.toString().replaceAll("Net Iskonto","Net Discount")
             bodyhtml=bodyhtml.toString().replaceAll("Toplam Kar","Total Profit")
             bodyhtml=bodyhtml.toString().replaceAll("Kar %","Profit %")
             bodyhtml=bodyhtml.toString().replaceAll("S. Adet","Sales C.")
             bodyhtml=bodyhtml.toString().replaceAll("I. Adet","Refund C.")
             bodyhtml=bodyhtml.toString().replaceAll("Dış Hat Toplam :","International Line Total:")
             bodyhtml=bodyhtml.toString().replaceAll("İç Hat Toplam :","Domestic Line Total:")
             bodyhtml=bodyhtml.toString().replaceAll("Total Kar","Total Profit")
             bodyhtml=bodyhtml.toString().replaceAll("Toplam Servis","Total Service")
             bodyhtml=bodyhtml.toString().replaceAll("İÇ HAT DAĞILIM RAPORU","DOMESTIC DISTRIBUTION REPORT")
             bodyhtml=bodyhtml.toString().replaceAll("DIŞ HAT DAĞILIM RAPORU","INTERNATIONAL DISTRIBUTION REPORT")
             bodyhtml=bodyhtml.toString().replaceAll("DÖNEMİ","PERIOD")
             bodyhtml=bodyhtml.toString().replaceAll("Toplam Servis","Total Service")
             bodyhtml=bodyhtml.toString().replaceAll("Before Dönem :","Previous period")
             
           
             response.bodyText=bodyhtml;
             
          }
            var blob = new Blob([response.bodyText], {
              type: 'application/html'
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = "SatisDagilimMukayase.html";
            link.click();

            this.itemsichat = response.body.DonemDagilimList.IcHatDetay
            this.itemsdishat = response.body.DonemDagilimList.DisHatDetay
            this.dipToplamichat = response.body.DonemDagilimList.IcHatToplamlar
            this.dipToplamdishat = response.body.DonemDagilimList.DisHatToplamlar
            this.dipToplamgenel = response.body.DonemDagilimList.GenelToplamlar


            this.onitemsichat = response.body.OncekiDonemDagilimList.IcHatDetay
            this.onitemsdishat = response.body.OncekiDonemDagilimList.DisHatDetay
            this.ondipToplamichat = response.body.OncekiDonemDagilimList.IcHatToplamlar
            this.ondipToplamdishat = response.body.OncekiDonemDagilimList.DisHatToplamlar
            this.ondipToplamgenel = response.body.OncekiDonemDagilimList.GenelToplamlar


          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            }
          })
        }



      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }

  }


  function getListExcel() {

    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false

        var listreferans = [];


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        if (this.Rapor.RaporTip == 'Masraf') {
          this.Rapor.DegiskenAlan = this.masrafmerkezikodu
        }
        if (this.Rapor.RaporTip == 'Havayolu') {
          this.Rapor.DegiskenAlan = this.havayolukodu
        }
        if (this.Rapor.RaporTip == 'Referans') {
          this.Rapor.DegiskenAlan = this.referansdegeri
        }
        if (this.Rapor.RaporTip == 'Bolum') {
          this.Rapor.DegiskenAlan = this.bolumdegeri
        }
        if (this.Rapor.RaporTip == 'KesenKisi') {
          this.Rapor.DegiskenAlan = this.kesenkisi
        }

        var params = this.Rapor

        if (this.RaporDurumu == '0') {
          this.Rapor.OncekiBaslangicTarih = null
          this.Rapor.OncekiBitisTarih = null


          this.$http.post(auth.API_URL + "api/TicketReport/SalesDistributionReportExcel", params, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            },
            responseType: "arraybuffer"
          }).then((response) => {

            this.itemsichat = response.body.IcHatDetay
            this.itemsdishat = response.body.DisHatDetay
            this.dipToplamichat = response.body.IcHatToplamlar
            this.dipToplamdishat = response.body.DisHatToplamlar
            this.dipToplamgenel = response.body.GenelToplamlar



            this.progress = false
            this.load1 = true
            var blob = new Blob([response.data], {
              type: 'application/xlsx'
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = "SatisDagilim.xlsx";
            link.click();

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            }
          })
        } else {

          this.$http.post(auth.API_URL + "api/TicketReport/SalesDistributionWithComparisonReportExcel", params, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            },
            responseType: "arraybuffer"
          }).then((response) => {


            this.progress = false
            this.load1 = true
            var blob = new Blob([response.data], {
              type: 'application/xlsx'
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = "SatisDagilimMukayese.xlsx";
            link.click();


            this.itemsichat = response.body.DonemDagilimList.IcHatDetay
            this.itemsdishat = response.body.DonemDagilimList.DisHatDetay
            this.dipToplamichat = response.body.DonemDagilimList.IcHatToplamlar
            this.dipToplamdishat = response.body.DonemDagilimList.DisHatToplamlar
            this.dipToplamgenel = response.body.DonemDagilimList.GenelToplamlar


            this.onitemsichat = response.body.OncekiDonemDagilimList.IcHatDetay
            this.onitemsdishat = response.body.OncekiDonemDagilimList.DisHatDetay
            this.ondipToplamichat = response.body.OncekiDonemDagilimList.IcHatToplamlar
            this.ondipToplamdishat = response.body.OncekiDonemDagilimList.DisHatToplamlar
            this.ondipToplamgenel = response.body.OncekiDonemDagilimList.GenelToplamlar


          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            }
          })
        }



      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }

  }


  function beforeMount() {



  }
</script>
<style scoped>

.sales-distribution-report-table{width:100%;}
</style>